export const privacyPolicyBodyIt = `Ultimo aggiornamento: 3 Ottobre 2026

La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che utilizzano il portale online di pro20.net per effettuare prenotazioni, ordini, richieste di informazioni e usufruire degli altri servizi messi a disposizione.

## 1. Titolare del trattamento

Il Titolare del trattamento dei dati personali è:

Mada Srl

Nome commerciale: Mada Srl

Sede: Via 4 novembre 12 - Cisternino (BR) 72014

P. IVA / C.F.: 02750160745

E-mail: {{email}}

PEC: -

Per qualsiasi richiesta relativa alla protezione dei dati personali è possibile contattare il Titolare utilizzando i recapiti sopra indicati.

Qualora sia stato nominato un Responsabile della Protezione dei Dati (DPO/RPD), è possibile contattarlo all'indirizzo:

{{email}}

## 2. Tipologie di dati trattati

Nell'ambito dell'utilizzo del portale possono essere raccolti e trattati, a seconda dei servizi utilizzati:

- nome e cognome;
- indirizzo e-mail;
- numero di telefono e relativo prefisso;
- informazioni relative alle prenotazioni;
- numero di persone associate alla prenotazione;
- data e ora della prenotazione;
- informazioni e richieste inserite volontariamente dall'utente;
- storico delle prenotazioni e delle presenze;
- informazioni relative agli ordini effettuati;
- prodotti e servizi acquistati;
- informazioni relative alla consegna o al ritiro degli ordini;
- informazioni relative alle transazioni e allo stato dei pagamenti;
- eventuali codici promozionali, coupon, punti o programmi fedeltà;
- preferenze e consensi espressi dall'utente;
- dati tecnici necessari al funzionamento e alla sicurezza del portale.

Si invita l'utente a non inserire nelle note o nelle richieste libere informazioni non necessarie, in particolare dati personali appartenenti a categorie particolari ai sensi dell'art. 9 GDPR, salvo quando strettamente necessario per la gestione della richiesta.

## 3. Finalità e basi giuridiche del trattamento

### 3.1 Prenotazioni

I dati personali vengono trattati per:

- ricevere e gestire una richiesta di prenotazione;
- confermare, modificare o annullare una prenotazione;
- contattare il cliente in relazione alla prenotazione;
- gestire l'arrivo e la presenza presso il ristorante;
- gestire eventuali richieste collegate alla prenotazione.

La base giuridica è l'esecuzione di un contratto o di misure precontrattuali richieste dall'interessato ai sensi dell'art. 6, par. 1, lett. b) GDPR.

## 4. Ordini, asporto e delivery

Qualora il portale permetta di effettuare ordini, i dati personali possono essere utilizzati per:

- ricevere e gestire l'ordine;
- preparare i prodotti ordinati;
- gestire il ritiro presso il locale;
- organizzare l'eventuale consegna;
- comunicare aggiornamenti sullo stato dell'ordine;
- gestire eventuali modifiche, cancellazioni o rimborsi;
- fornire assistenza al cliente.

La base giuridica è l'esecuzione del contratto o di misure precontrattuali richieste dall'interessato.

## 5. Pagamenti

Quando previsto, il portale può permettere il pagamento di ordini, depositi, caparre, servizi o altre somme attraverso fornitori specializzati di servizi di pagamento.

I dati necessari alla transazione possono essere comunicati direttamente al fornitore del servizio di pagamento.

Il ristorante e il portale possono ricevere informazioni relative all'esito della transazione, quali, ad esempio:

- pagamento effettuato;
- pagamento rifiutato;
- autorizzazione della carta;
- deposito effettuato;
- rimborso;
- identificativo della transazione.

I dati completi della carta di pagamento non vengono memorizzati dal ristorante quando il pagamento è gestito direttamente dal provider di pagamento.

La base giuridica è l'esecuzione del contratto e, ove applicabile, l'adempimento di obblighi di legge.

## 6. Comunicazioni relative al servizio

I recapiti forniti dall'utente possono essere utilizzati per inviare comunicazioni strettamente connesse al servizio richiesto, ad esempio:

- conferma della prenotazione;
- richiesta di conferma;
- modifica o cancellazione della prenotazione;
- promemoria della prenotazione;
- conferma dell'ordine;
- aggiornamento sullo stato dell'ordine;
- comunicazioni relative al pagamento;
- informazioni necessarie alla corretta esecuzione del servizio.

Tali comunicazioni potranno essere effettuate, a seconda dei recapiti forniti e dei servizi attivati dal ristorante, tramite e-mail, SMS, WhatsApp o altri sistemi di messaggistica.

Queste comunicazioni, quando strettamente necessarie alla gestione del servizio richiesto, non costituiscono comunicazioni promozionali.

## 7. Marketing e comunicazioni promozionali

Solo previo consenso dell'utente, i dati di contatto potranno essere utilizzati per l'invio di comunicazioni commerciali e promozionali relative a:

- offerte e promozioni;
- eventi;
- nuovi menu o prodotti;
- iniziative del ristorante;
- coupon e codici sconto;
- programmi fedeltà;
- comunicazioni commerciali personalizzate.

Le comunicazioni potranno essere inviate attraverso i canali per i quali l'utente abbia espresso il proprio consenso, quali e-mail, SMS, WhatsApp o altri strumenti consentiti dalla normativa applicabile.

Il conferimento del consenso per finalità di marketing è facoltativo.

Il mancato consenso non impedisce di effettuare prenotazioni, ordini o utilizzare gli altri servizi principali del portale.

Il consenso può essere revocato in qualsiasi momento, senza pregiudicare la liceità dei trattamenti effettuati prima della revoca.

## 8. Profilazione e personalizzazione

Solo ove prevista e previo consenso quando richiesto dalla normativa, il Titolare potrà utilizzare informazioni relative alle interazioni dell'utente con il ristorante per analizzare interessi, abitudini e preferenze.

A titolo esemplificativo, possono essere considerate informazioni quali:

- frequenza delle prenotazioni;
- storico degli ordini;
- prodotti acquistati;
- utilizzo di promozioni e coupon;
- partecipazione a programmi fedeltà;
- preferenze manifestate dall'utente;
- interazioni con comunicazioni promozionali.

Tali informazioni possono essere utilizzate per creare segmenti di clientela e rendere maggiormente pertinenti offerte, promozioni e comunicazioni.

Il consenso alla profilazione, quando richiesto, è facoltativo e può essere revocato in qualsiasi momento.

La mancata prestazione del consenso non impedisce l'utilizzo dei normali servizi di prenotazione e ordinazione.

## 9. Programmi fedeltà, promozioni e coupon

Qualora il ristorante metta a disposizione programmi fedeltà, promozioni, raccolte punti o coupon, i dati dell'utente possono essere trattati per:

- attribuire punti o vantaggi;
- verificare i requisiti per ottenere una promozione;
- generare coupon;
- verificare l'utilizzo dei coupon;
- gestire premi e vantaggi;
- prevenire utilizzi fraudolenti delle promozioni.

Le specifiche condizioni del programma o della promozione possono essere disciplinate da un apposito regolamento.

## 10. Automazioni

Il ristorante può utilizzare sistemi automatici per gestire alcune attività collegate al rapporto con il cliente.

Ad esempio, il sistema può automaticamente:

- inviare un promemoria prima di una prenotazione;
- inviare una comunicazione dopo una visita;
- aggiornare lo stato di una prenotazione o di un ordine;
- attribuire punti o coupon;
- inviare comunicazioni in seguito al verificarsi di determinate condizioni.

Quando tali automazioni hanno finalità promozionali o comportano profilazione, vengono applicate le relative basi giuridiche e, quando necessario, richiesto preventivamente il consenso dell'utente.

## 11. Conferimento dei dati

Il conferimento dei dati contrassegnati come obbligatori è necessario per poter fornire il servizio richiesto.

Ad esempio, il mancato conferimento dei dati necessari alla prenotazione può rendere impossibile completare la prenotazione stessa.

Il conferimento dei dati e del consenso per finalità di marketing e profilazione è invece facoltativo e non condiziona l'accesso ai servizi principali.

## 12. Destinatari dei dati

I dati personali possono essere trattati da personale autorizzato dal Titolare e da fornitori che prestano servizi necessari al funzionamento dell'attività e della piattaforma.

A titolo esemplificativo, possono rientrare tra tali soggetti:

- fornitori della piattaforma informatica;
- hosting provider e fornitori cloud;
- fornitori di servizi e-mail;
- fornitori di servizi SMS;
- fornitori di servizi di messaggistica;
- fornitori di servizi di pagamento;
- fornitori di servizi di delivery;
- consulenti tecnici, amministrativi o fiscali;
- altri soggetti che trattano dati per conto del Titolare.

Quando previsto dalla normativa, tali soggetti operano in qualità di Responsabili del trattamento ai sensi dell'art. 28 GDPR.

I dati potranno inoltre essere comunicati alle autorità competenti quando previsto da obblighi di legge.

## 13. Trasferimento dei dati fuori dallo Spazio Economico Europeo

Alcuni fornitori tecnologici utilizzati dal Titolare potrebbero trattare dati personali al di fuori dello Spazio Economico Europeo.

In tali casi il trattamento e il trasferimento dei dati avverranno nel rispetto delle disposizioni previste dal GDPR, mediante gli strumenti e le garanzie applicabili, quali decisioni di adeguatezza o Clausole Contrattuali Standard approvate dalla Commissione Europea, ove necessarie.

## 14. Periodo di conservazione

I dati personali vengono conservati per il tempo necessario al perseguimento delle finalità per cui sono stati raccolti e successivamente per gli eventuali periodi richiesti dalla normativa applicabile.

In particolare:

- i dati relativi a prenotazioni e ordini saranno conservati per il periodo necessario alla gestione del rapporto con il cliente e agli eventuali obblighi amministrativi, contabili o legali;
- i dati relativi alle transazioni saranno conservati secondo gli obblighi fiscali e contabili applicabili;
- i dati utilizzati per finalità di marketing saranno conservati fino alla revoca del consenso o per il diverso periodo individuato dal Titolare secondo i principi di necessità e proporzionalità;
- i dati utilizzati per profilazione saranno conservati per il periodo definito dal Titolare in relazione alle finalità perseguite e successivamente cancellati o anonimizzati.

I tempi specifici di conservazione adottati dal Titolare possono essere richiesti utilizzando i recapiti indicati nella presente informativa.

## 15. Sicurezza dei dati

Il Titolare e i fornitori coinvolti adottano misure tecniche e organizzative adeguate al rischio al fine di proteggere i dati personali da perdita, distruzione, accesso non autorizzato, divulgazione, modifica o trattamento illecito.

## 16. Diritti dell'interessato

Nei casi previsti dal GDPR, l'interessato può esercitare i propri diritti e in particolare richiedere:

- l'accesso ai propri dati personali;
- la rettifica dei dati inesatti;
- la cancellazione dei dati;
- la limitazione del trattamento;
- la portabilità dei dati;
- l'opposizione al trattamento;
- la revoca del consenso precedentemente prestato.

La revoca del consenso non pregiudica la liceità del trattamento effettuato prima della revoca.

Le richieste possono essere inviate a:

{{email}}

L'interessato ha inoltre il diritto di proporre reclamo all'Autorità Garante per la protezione dei dati personali secondo le modalità previste dalla normativa vigente.

## 17. Cookie e tecnologie analoghe

Il portale può utilizzare cookie e altre tecnologie necessarie al proprio funzionamento.

L'eventuale utilizzo di cookie analitici, di profilazione o appartenenti a terze parti è disciplinato dalla specifica Cookie Policy disponibile sul portale e, quando necessario, attraverso il sistema di gestione del consenso.

## 18. Modifiche alla presente informativa

Il Titolare può aggiornare periodicamente la presente informativa per adeguarla a modifiche normative, tecniche o ai servizi offerti.

La versione aggiornata sarà resa disponibile attraverso il portale.

Ultimo aggiornamento: 03 Ottobre 2026`;
